import { Model } from '@nozbe/watermelondb';
import { field } from '@nozbe/watermelondb/decorators';

function parseJsonList(value: string): unknown[] {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export default class DemoPaymentInformation extends Model {
  static table = 'demo_payment_information';

  @field('bp_payment_status') bpPaymentStatus!: boolean;
  @field('bp_payment_amount') bpPaymentAmount!: number;
  @field('bp_payment_amount_received') bpPaymentAmountReceived!: number;
  @field('bp_payment_already_paid_amount') bpPaymentAlreadyPaidAmount!: number;
  @field('bp_payment_amount_actually_received')
  bpPaymentAmountActuallyReceived!: number;
  @field('bp_payment_amount_due') bpPaymentAmountDue!: number;
  @field('bp_payment_amount_refunded') bpPaymentAmountRefunded!: number;
  @field('bp_payment_refunds') bpPaymentRefunds!: string;
  @field('bp_order_information_id') bpOrderInformationId!: string;
  @field('bp_payment_created_at') bpPaymentCreatedAt!: number;
  @field('bp_payment_updated_at') bpPaymentUpdatedAt!: number;
  @field('bp_payment_deleted_at') bpPaymentDeletedAt!: number;
  @field('bp_payments') bpPayments!: string;
  @field('bp_payment_location_id') bpPaymentLocationId!: string;
  @field('bp_payment_method') bpPaymentMethod!: string;

  get payments() {
    return parseJsonList(this.bpPayments);
  }

  get paymentRefunds() {
    return parseJsonList(this.bpPaymentRefunds);
  }

  getRemainingAmount(): number {
    if (
      typeof this.bpPaymentAmount === 'number' &&
      typeof this.bpPaymentAlreadyPaidAmount === 'number'
    ) {
      return this.bpPaymentAmount - this.bpPaymentAlreadyPaidAmount;
    }
    return this.bpPaymentAmount;
  }

  toPaymentObject() {
    return {
      _id: this.id,
      bp_payment_status: this.bpPaymentStatus,
      bp_payment_amount: this.bpPaymentAmount,
      bp_payment_amount_received: this.bpPaymentAmountReceived,
      bp_payment_already_paid_amount: this.bpPaymentAlreadyPaidAmount,
      bp_payment_amount_actually_received: this.bpPaymentAmountActuallyReceived,
      bp_payment_amount_due: this.bpPaymentAmountDue,
      bp_payment_amount_refunded: this.bpPaymentAmountRefunded,
      bp_payment_refunds: this.paymentRefunds,
      bp_order_information_id: this.bpOrderInformationId,
      bp_payment_created_at: this.bpPaymentCreatedAt,
      bp_payment_updated_at: this.bpPaymentUpdatedAt,
      bp_payment_deleted_at: this.bpPaymentDeletedAt,
      bp_payments: this.payments,
      bp_payment_location_id: this.bpPaymentLocationId,
      bp_payment_method: this.bpPaymentMethod,
    };
  }
}
